/*Imports*/
import React from "react";
import AxiosConfig from "axiosConfig";
import * as CONSTANT from "constants/text";
import MemberGroupProfile from "containers/Tribe/Groups/GroupProfile/MemberGroupProfile";
import NonMemberGroupProfile from "containers/Tribe/Groups/GroupProfile/NonMemberGroupProfile";

class GroupProfileDetail extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      groupId: this.props.match.params.group_id,
      type: this.props.match.params.type,
      groupDetails: "",
      role: "",
      inviteStatus: "",
    };
  }

  /*When component mounts fetch the group info*/
  componentDidMount() {
    // get the group profile information
    this.fetchGroupProfile(this);
  }

  /*Fetch group information and store it in the state*/
  fetchGroupProfile(obj) {
    AxiosConfig.get(`groups/details/${this.state.groupId}/`).then(function (
      response
    ) {
      obj.setState({
        groupDetails: response.data,
        role: response.data.role,
        inviteStatus: response.data.invite_status,
      });
    });
  }

  render() {
    return (
      <div>
        {(this.state.role === CONSTANT.MEMBER ||
          this.state.role === CONSTANT.OWNER ||
          this.state.role === CONSTANT.MODERATOR) &&
        this.state.type !== CONSTANT.GUARDIAN_REVIEW ? (
          <MemberGroupProfile
            groupDetails={this.state.groupDetails}
            role={this.state.role}
            groupId={this.state.groupId}
            groupName={this.props.match.params.groupName}
            type={this.props.match.params.type}
            history={this.props.history}
          />
        ) : this.state.role === "none" || this.state.type == CONSTANT.GUARDIAN_REVIEW ? (
          <NonMemberGroupProfile
            groupDetails={this.state.groupDetails}
            inviteStatus={this.state.inviteStatus}
            groupId={this.props.match.params.group_id}
            history={this.props.history}
            match={this.props.match}
          />
        ) : null}
      </div>
    );
  }
}

export default GroupProfileDetail;
